import React from 'react';
import './Grief.css';

const Grief = () => {
  return (
    <div className="grief">
      <div className="grief-container">
        <div className="grief-header">
          <h1>Grief</h1>
          <p>
            "Grief is the price we pay for attachment. The stronger the bond, the deeper the grief--not because something has gone
            wrong, but because something was deeply right." -John Bowlby
          </p>
        </div>
        
        <div className="grief-content">
          <div className="grief-approach">
            <h2>My Approach to Grief</h2>
            <p>
              I wholeheartedly believe that grief is not a problem to be solved. Grief is a normal and natural response 
              to both death and non-death losses. For many, 
              losing an attachment figure is one of the most painful human experiences. Grieving is the process of adjusting to the loss.
            </p>
            <p>
              I believe that each one of us has the ability to adapt to loss, but sometimes we may feel stuck. I will be a compassionate guide
              and help you learn more skilled responses to suffering during grieving. 
            </p>
            <div className="skills-list">
              <h3>Some of these skills include:</h3>
              <ul>
                <li>Grief psychoeducation</li>
                <li>Continuing bonds</li>
                <li>Distress tolerance</li>
                <li>Spiritual integration</li>
                <li>Meaning-Making</li>
                <li>Mindfulness</li>
                <li>Emotion regulation</li>
                <li>Parts work</li>
                <li>Interpersonal effectiveness</li>
              </ul>
            </div>
            
          </div>
          
          <div className="grief-specialties">
            <h2>My Grief Specialties</h2>
            <div className="specialties-grid">
              <div className="specialty-item">
                <h4>Ambiguous Loss</h4>
                <p>The loss is unclear and lacks closure</p>
              </div>
              <div className="specialty-item">
                <h4>Complex Grief</h4>
                <p>Loss associated with attachment wounds</p>
              </div>
              <div className="specialty-item">
                <h4>Disenfranchised Loss</h4>
                <p>Loss is not openly acknowledged</p>
              </div>
              <div className="specialty-item">
                <h4>Prolonged Grief Disorder</h4>
                <p>Grief that feels "stuck"</p>
              </div>
              <div className="specialty-item">
                <h4>Spiritual Issues & Meaning-Making</h4>
                <p>Finding purpose and understanding in loss</p>
              </div>
              <div className="specialty-item">
                <h4>Traumatic Loss</h4>
                <p>Sudden, unexpected loss</p>
              </div>
            </div>
          </div>

          <div className="grief-resources">
            <h2>Additional Resources</h2>
            <p>
              Please see{' '}
              <a 
                href="https://thegrieftherapistsoftexascollective.org/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="external-link"
              >
                https://thegrieftherapistsoftexascollective.org/
              </a>{' '}
              to learn more about the Grief Therapists of Texas Collective in which I am a member.
            </p>
          </div>

          <div className="grief-experience">
            <h2>My Experience</h2>
            <p>
              I have extensive training in grief and loss and have worked in a non-profit grief center supporting
              individuals and families through bereavement. I currently work with clients navigating a wide range of losses
              and provide culturally responsive care to diverse populations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grief;
